import React from 'react';

const Features = () => {
    return (
	<div className="section features">
	    <div className="itemsWrapper">
		<div className="item title">
		    <h2>discuss, organize, remember</h2>
		</div>
		<div className="item">
		    <div className="imgWrapper">
			<div className="img img1" />
		    </div>
		    <div className="text">
			<h4>Private Chats</h4>
			<p>Discuss anything, share pictures, attach files, tasks, and lists, all only between participants.</p>
		    </div>
		</div>
		<div className="item">
		    <div className="imgWrapper">
			<div className="img img2" />
		    </div>
		    <div className="text">
			<h4>Private Documents</h4>
			<p>Write with different blocks — text, lists, images, videos, files, links, tables and nested pages.</p>
		    </div>
		</div>
		<div className="item">
		    <div className="imgWrapper">
			<div className="img img3" />
		    </div>
		    <div className="text">
			<h4>Private Databases</h4>
			<p>Keep track of people, tasks, and resources to manage relationships and projects.</p>
		    </div>
		</div>
	    </div>
	</div>
    );
};

export default Features;